import { Stack, Typography, useTheme } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import React, { useState } from 'react';
import { Schema } from '../../../../../../amplify/data/resource';
import EditContact from './EditContact';

// @ts-ignore
type Contact = Schema['Contact']['type'];

const apiClient = generateClient<Schema>();

interface Props {
  contactItem: Contact;
  userId: string;
}

const ContactItem: React.FC<Props> = ({ contactItem, userId }) => {
  const theme = useTheme();

  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Stack
      spacing={2}
      sx={{
        px: '40px',
        py: '20px',
        maxWidth: '400px',
        background: '#F2F4F7',
        borderRadius: '30px',
      }}
    >
      <Stack direction="row" justifyContent={'space-between'}>
        <Stack direction="row" spacing={1}>
          <img
            alt="logo"
            src={'/assets/client/edit.svg'}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setDialogOpen(true);
            }}
          />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            whiteSpace="nowrap"
            fontSize="24px"
            fontWeight="700"
            fontFamily={'AlmoniDL'}
          >
            {contactItem?.type}
          </Typography>
          <img alt="logo" src={'/assets/client/client.svg'} />
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent={'space-between'}>
        <Item widthBlock title={'הערות'} value={contactItem?.notes || ''} />
        <Stack spacing={1} width={'50%'} alignItems={'flex-end'}>
          <Item widthBlock title={'שם '} value={contactItem?.fullName} />
          <Item title={'ח.פ.'} value={contactItem?.phone} />
          <Item title={'שם מורשה חתימה'} value={contactItem?.email} />
        </Stack>
      </Stack>
      <EditContact
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        contactId={contactItem?.id}
        userId={userId}
      />
    </Stack>
  );
};

export default ContactItem;

interface ItemProps {
  title: string | undefined;
  value: string | undefined;
  widthBlock?: boolean;
}

const Item: React.FC<ItemProps> = ({ title, value, widthBlock }) => {
  return (
    <Stack sx={{ width: '50%' }}>
      <Typography
        dir="rtl"
        fontSize="14px"
        fontWeight="700"
        fontFamily="AlmoniDL"
      >
        {title || 'XXXXXXXXXX'}
      </Typography>
      <Typography
        dir="rtl"
        fontSize="14px"
        fontWeight="300"
        fontFamily="AlmoniDL"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 5, // Максимум 5 строк
          WebkitBoxOrient: 'vertical',
          wordBreak: 'break-word', // Перенос по словам
        }}
      >
        {value || 'XXXXXXXXXX'}
      </Typography>
    </Stack>
  );
};
